import React, { Component } from 'react';
import envStatic from '../../../envStatic';
import { getUserFactoryId } from '../../../index';
import { BIRender } from '../../components/PowerBIRender/BIRender';

class UXPage extends Component {

    render() {
        const userFactory = getUserFactoryId();
        return (<BIRender filters={``} reportSection={envStatic.reportSectionUX} />)
    }
}

export default UXPage